// Timing configuration for various operations
export const TIMING_CONFIG = {
  // Batch operation delays
  BATCH_OPERATION_DELAY_MS: 500,

  // Edge creation delays
  EDGE_SEMAPHORE_WAIT_MS: 100,

  // Node execution delays
  NODE_EXECUTION_DELAY_MS: 1000,
  // Retry configuration
  RETRY_BASE_DELAY_MS: 1000,

  RETRY_JITTER_MAX_MS: 500,

  RETRY_MAX_ATTEMPTS: 3,
  STORE_INVALIDATION_DELAY_MS: 1000,
  // Workflow execution delays
  WORKFLOW_EXECUTION_DELAY_MS: 500,
} as const;
